import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { MOPRA_VECTOR } from '../config/services'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import DataActions from '../redux/dataRedux'
import { makeGetEventData } from '../selectors/eventDataSelector'

const id = 'MopraVector'
const authId = 'Mopra'
const sourceLayer = 'ReclaimedWellsites'

const setCharAt = (str, index, chr) => {
  if (index > str.length - 1) return str
  return str.substr(0, index) + chr + str.substr(index + 1)
}

const formatVectorDate = datetime => {
  if (!datetime) {
    return ''
  }

  return setCharAt(datetime, 10, ' ').slice(0, datetime.length - 1)
}

export class MopraVector extends Component {
  componentDidMount () {
    const { map } = this.context
    map.on('mousemove', id, this.handleMouseMove)
  }

  componentWillUnmount () {
    const { map } = this.context
    map.off('mousemove', id, this.handleMouseMove)
  }

  handleMouseMove = event => {
    const { map } = this.context
    const { actions, layerRendered } = this.props
    if (!layerRendered) {
      return
    }
    
    const features = map.queryRenderedFeatures(event.point, {
      layers: [id]
    })

    const data = features.map(feature => feature.properties)
    if (data) {

      actions.dataUpdated(data[0], 'hover')
    }
  }
  
  shouldComponentUpdate (nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps.hovered !== this.props.hovered) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps (props) {
    const { paint, layout, before, layerOptions, hovered } = this.props
    // TODO: handle array of ids, so highlight layers can also be controlled
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (!isEqual(props.hovered, hovered)) {
      if (hovered.ndvi) {
        const filter = ['in', 'ndvi'].concat(props.hovered.ndvi)
        map.getLayer(`${id}Hovered`) && map.setFilter(`${id}Hovered`, filter)
      }
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render () {
    const { idToken, layerRendered, paint, time, datetime } = this.props
    const visible = layerRendered
    const timeIso = time ? new Date(time).toISOString() : ''

    if (!visible) {
      return null
    }

    const vectorSource = {
      type: 'vector',
      tiles: [MOPRA_VECTOR({ idToken, timeIso })],
      tileSize: 512
    }

    return (
      <div>
        <Source
          key='mopraVectorSource'
          id={id}
          tileJsonSource={vectorSource}
        />
        <Layer
          type='fill'
          id={id}
          sourceId={id}
          sourceLayer={sourceLayer}
          filter={['==', 'timestamp', datetime]}
          paint={paint}
        />
        <Layer
          type='fill'
          id={`${id}Hovered`}
          sourceId={id}
          sourceLayer={sourceLayer}
          filter={['in', 'ndvi', '']}
          paint={{
            'fill-opacity': 0.2,
            'fill-color': 'blue'
          }}
        />
        <Layer
          type='fill'
          id='mopraVectorWellsiteHighlight'
          sourceId={id}
          sourceLayer={sourceLayer}
          filter={['in', 'well_name', '']}
          paint={{
            'fill-opacity': 0.05,
            'fill-color': 'white'
          }}
        />
        <Layer
          type='fill'
          id='mopraVectorAreaHighlight'
          sourceId={id}
          sourceLayer={sourceLayer}
          filter={['in', 'area', '']}
          paint={{
            'fill-opacity': 0.05,
            'fill-color': 'blue'
          }}
        />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const getDatetime = makeGetDatetime()
  const getEventData = makeGetEventData()

  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(
        state,
        'MopraVector',
        'ReclaimedWellsites'
      ),
      paint: getPaint(state, id),
      time: state.layer.times.Mopra || undefined,
      datetime: formatVectorDate(getDatetime(state, 'Mopra')) || '',
      hovered: getEventData(state, id)
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      dataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, id, event))
    }
  }
}

export default connect(makeMapStateToProps(), mapDispatchToProps)(MopraVector)



// WEBPACK FOOTER //
// ./src/layers/MopraVector.js